import React, { useRef } from "react"
import { StaticImage } from "gatsby-plugin-image"
import {
  Layout,
  Seo,
  ContactForm,
  Section,
  Nav,
  HeaderContent,
} from "../components"
import { title, subtitle, description, contactData } from "../data/findUs"
import { useOnScreen } from "../utils/hooks"

export default function FindUs() {
  const ref = useRef()
  const isHeaderVisible = useOnScreen(ref)
  return (
    <Layout>
      <Seo title="Need more information about pushfusion platform? Contact us!" />

      <div>
        <Nav isHeaderVisible={isHeaderVisible} />
        <div className="relative bg-gray-900 overflow-hidden" ref={ref}>
          <div className="relative pt-6 pb-16 sm:pb-24 lg:pb-32">
            <HeaderContent
              title={{
                firstSentence: title,
                secondSentence: subtitle,
              }}
              description={
                <div className="sm:-mb-6">
                  {description.map(item => {
                    if (item.bold) {
                      return <h3 className="text-gray-50">{item.text}</h3>
                    } else {
                      return <p className="pb-6">{item.text}</p>
                    }
                  })}
                </div>
              }
              media={
                <StaticImage
                  src="../assets/images/office.jpeg"
                  alt="Image of pushfusion interface on a mac book showing some Casambi devices."
                  placeholder="blurred"
                  layout="constrained"
                  quality={100}
                  height={430}
                  loading="eager"
                  aspectRatio={16 / 9}
                  className="rounded-lg"
                />
              }
            />
          </div>
        </div>
      </div>

      <ContactForm />
      <Section>
        <p className="text-3xl text-gray-700 tracking-tight ">
          Prefer to get in touch another way?
        </p>

        <div className="mt-10 grid grid-cols-1 gap-10 sm:grid-cols-2 lg:grid-cols-4">
          {contactData.map(contact => (
            <div key={contact.id}>
              <h3 className="text-lg font-bold text-pushfusion">
                {contact.name}
              </h3>
              <p className="mt-2 text-base text-gray-500">
                {contact.address.map(line => (
                  <span key={line} className="block">
                    {line}
                  </span>
                ))}
              </p>
            </div>
          ))}
        </div>
      </Section>
    </Layout>
  )
}
